(function () {
  function headerFor(element) {
    return element && element.closest
      ? element.closest(".relenser-site-header")
      : document.querySelector(".relenser-site-header");
  }

  window.toggleRelenserMenu = function (button) {
    var header = headerFor(button);
    var menu = header && header.querySelector("#RelenserMobileMenu");
    if (!menu) return;
    var open = menu.classList.toggle("open");
    button.setAttribute("aria-expanded", open ? "true" : "false");
  };

  window.closeRelenserMenu = function () {
    var header = document.querySelector(".relenser-site-header");
    if (!header) return;
    var menu = header.querySelector("#RelenserMobileMenu");
    var button = header.querySelector(".hamburger");
    if (menu) menu.classList.remove("open");
    if (button) button.setAttribute("aria-expanded", "false");
  };

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") window.closeRelenserMenu();
  });
})();

